import React from "react";
import { Switch } from "react-router-dom";
import TopicsPage from "app/topics/TopicsPage";
import Topic from "app/topics/Topic";
import AuthRoute from "app/auth/AuthRoute";

export default props => {
  const { match } = props;
  return (
    <Switch>
      <AuthRoute
        path={`${match.url}/:topicId/p/:proposalId/:proposalAction?`}
        component={Topic}
      />
      <AuthRoute
        path={`${match.url}/:topicId/:topicAction(proposals/[^\\/]+)`}
        component={Topic}
        checkAuth
        exact
      />
      <AuthRoute
        path={`${match.url}/:topicId/:topicAction(proposals|p|details)`}
        component={Topic}
      />
      <AuthRoute path={`${match.url}/:topicId/legend`} component={Topic} />
      <AuthRoute path={`${match.url}/:topicId`} component={Topic} />
      <AuthRoute component={TopicsPage} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/app/topics/index.js